import { Button, TextInput } from "@mantine/core";
import RoutesInstance from "@routes/instances";
import { useEffect, useState } from "react";
import { BiPlus, BiSearch } from "react-icons/bi";
import {
    Link,
    useLocation,
    useNavigate,
    useSearchParams,
} from "react-router-dom";

const Filters = () => {
    const [filters, setFilters] = useState({
        query: "",
    });

    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    useEffect(() => {
        setFilters({
            ...filters,
            query: URLSearchParams.get("query") || "",
        });
    }, [URLSearchParams]);

    const handleSearch = () => {
        Object.entries(filters).map(([key, value]) =>
            URLSearchParams.set(key, value),
        );

        Navigate(
            {
                pathname,
                search: "?" + URLSearchParams.toString(),
            },
            {
                replace: true,
            },
        );
    };

    return (
        <div>
            <div className="bg-white p-4 rounded shadow mb-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <TextInput
                        variant="filled"
                        color="blue"
                        label="جست و جو بر اساس نام"
                        placeholder="جست و جو بر اساس نام"
                        value={filters.query}
                        classNames={{
                            error: "text-sm",
                            label: "mb-2 text-gray-700 font-medium",
                        }}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                query: e.target.value,
                            })
                        }
                    />
                </div>
            </div>

            <section className="flex items-center justify-end mb-4">
                <Link to={RoutesInstance.createGallery} className="ml-2">
                    <Button color="green" leftIcon={<BiPlus />}>
                        عکس جدید
                    </Button>
                </Link>

                <Button leftIcon={<BiSearch />} onClick={handleSearch}>
                    جست و جو
                </Button>
            </section>
        </div>
    );
};

export default Filters;
